<template>
  <div>
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
export default {
  props:{
    series:{
      type: Array
    }
  },
  computed: {
    chartOptions(){
      return {
        title: {
          text: null
        },
        chart:{
          height: '300px'
        },
        plotOptions:{
          wordcloud:{
            maxFontSize:25,
            minFontSize:5
          }
        },
        series: this.series
      }
    }
  }
};
</script>
